import React, { useState, useEffect } from "react";
import "./AllCoursesPage.css";
import data from "./data";
import InquiryForm from "./InquiryForm";

// Banner images
import img1 from "./img/1036122_94763-OJZRTG-987.jpg";
import img2 from "./img/172780645_10005362.jpg";
import img3 from "./img/20684276_2106.w023.n001.556B.p1.556.jpg";
import img4 from "./img/26195939_programmer_text_2.jpg";
import img5 from "./img/4015688_118.jpg";
import img6 from "./img/53607.jpg";
import img7 from "./img/53925.jpg";
import img8 from "./img/28159021_site_design_12.jpg";

export default function AllCoursesPage() {
  const [showForm, setShowForm] = useState(false);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  const bannerImages = [img1, img2, img3, img4, img5, img6, img7, img8];

  // Auto-scroll banner
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % bannerImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [bannerImages.length]);

  const handleEnrollClick = (courses) => {
    setSelectedCourses(courses.flat());
    setShowForm(true);
  };

  // Filter categories if search term is entered
  const filteredData = searchTerm
    ? Object.keys(data).reduce((acc, category) => {
        const matches = data[category].some((col) =>
          col.some((item) =>
            item.toLowerCase().includes(searchTerm.toLowerCase())
          )
        );
        if (matches) acc[category] = data[category];
        return acc;
      }, {})
    : data;

  return (
    <div className="all-courses-page">
      {/* 🔹 Full-width Banner Section */}
      <div className="banner">
        <div
          className="banner-images"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {bannerImages.map((img, idx) => (
            <img key={idx} src={img} alt={`banner-${idx}`} />
          ))}
        </div>
      </div>

      {/* Header with search */}
      <div className="header-row">
        <h1>All Courses</h1>
        <input
          type="text"
          className="search-box"
          placeholder="Search courses..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Courses */}
      <div className="courses-container">
        {Object.keys(filteredData).length === 0 ? (
          <p className="no-results">No courses found.</p>
        ) : (
          Object.keys(filteredData).map((category, index) => (
            <div key={index} className="course-category">
              <h2>{category}</h2>
              <div className="course-columns">
                {filteredData[category].map((col, colIndex) => (
                  <ul key={colIndex} className="course-list">
                    {col.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                ))}
              </div>
              <div className="enroll-btn-container">
                <button
                  className="enroll-btn"
                  onClick={() => handleEnrollClick(filteredData[category])}
                >
                  Enroll
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Inquiry Form */}
      {showForm && (
        <InquiryForm
          courses={selectedCourses}
          onClose={() => setShowForm(false)}
        />
      )}
    </div>
  );
}
